module.exports = __webpack_public_path__ + "img/Eternal_Rose.81ad0b7a.png";